<template>
  <div class="row">

    <div class="col">
      <a id="btnAddUser" class="btn link-with-icon" @click="addUser" @keyup.enter="addUser">
        <img src="@/assets/img/icons/user.svg" :alt="$t('adm.button.addUser')">
        {{ $t('adm.button.addUser') }}
      </a>
    </div>

    <div class="col" v-if="myRole === 'orgSuperAdmin' || myRole === 'superAdmin'">
      <a
        id="btnMoveAll"
        class="btn link-with-icon dropdown-toggle"
        data-bs-toggle="dropdown"
        data-bs-config='{"autoClose":false}'
        ref="moveBtn">
        <img src="@/assets/img/icons/external-link.svg" :alt="$t('adm.page.organization.openMoveUsers')">
        {{ $t('adm.page.organization.openMoveUsers') }}
      </a>

      <form class="dropdown-menu dropdown-menu-lg-end w-25 p-4">
        <the-overlay :active="state === 'MOVING'">
          <form-item-group
            container-class="col"
            :required="true"
            :validation="v$.newOrganization"
            :label="$t('adm.page.organization.newOrg')"
            label-for="toOrg">
            <select1-organization
              id="toOrg"
              v-model="newOrganization"
              @update:model-value="newOrganization = $event" />
          </form-item-group>
          <div class="buttons">
            <input
              type="button"
              class="btn btn-primary w-100"
              :value="$t('adm.page.organization.saveMove')"
              :disabled="!newOrganization || newOrganization === orgId"
              @click="moveUsers" />
          </div>
        </the-overlay>
      </form>
    </div>

  </div>
</template>
<script lang="ts">
import Select1Organization from '@/components/ui/Select1Organization.vue';
import { defineComponent } from 'vue';

import { i18n } from '@/lang';
import FormItemGroup from '@/components/ui/FormItemGroup.vue';
import { required } from '@/components/validators';
import useVuelidate from '@vuelidate/core';
import { mapState } from 'pinia';
import useAppStore from '@/components/store';
import Backend from '@/components/backend';
import TheOverlay from '@/components/ui/TheOverlay.vue';
import { Dropdown } from 'bootstrap';

export default defineComponent({
  name: 'TitleButtons',
  components: { TheOverlay, FormItemGroup, Select1Organization },
  emits: ['add:clicked', 'usersMoved'],

  props: {
    orgId: { type: String, required: true },
  },

  data: () => ({
    newOrganization: '',
    state: '',
  }),

  methods: {
    /// add user clicked - go to user create page
    addUser() {
      this.$emit('add:clicked');
      this.$router.push(`/${i18n.global.locale}/members/create?org=${this.orgId}`);
    },
    /// move users clicked - move users
    async moveUsers() {
      this.state = 'MOVING';

      try {
        const api = await Backend.validateToken();
        const resp = await api.moveUsers(this.orgId, this.newOrganization);

        this.moveDropdown.hide();
        this.$toast.success(this.$t('adm.page.organization.infoSuccess', [resp.data]), { duration: 5000 });

        this.$emit('usersMoved', this.newOrganization);
      } catch (_e) {
        this.$toast.error(this.$t('adm.error.generic'));
      }

      this.state = '';
    },
  },

  computed: {
    // inject state getters
    ...mapState(useAppStore, {
      myRole: 'getMyAdminRole',
    }),
    moveDropdown() {
      return Dropdown.getOrCreateInstance(this.$refs.moveBtn as HTMLElement);
    },
  },

  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      newOrganization: { required },
    };
  },
});
</script>
